"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.array.filter");

require("core-js/modules/es.array.map");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ramda = require("ramda");

var _mapFilterFieldsToQuery = _interopRequireDefault(require("./mapFilterFieldsToQuery"));

var _mergeQuery = _interopRequireDefault(require("./mergeQuery"));

var joinFilterFields = function joinFilterFields(filterFields) {
  return function (query) {
    return (0, _ramda.isEmpty)(filterFields) ? query : (0, _mergeQuery.default)(query, (filterFields || []).map(_mapFilterFieldsToQuery.default).filter(function (i) {
      return !!i;
    }));
  };
};

var _default = joinFilterFields;
exports.default = _default;